import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { useLocalStorage } from "@circle-react/hooks/utils/useLocalStorage";
import { useEffect } from "react";

import { useCircleAIIntroModal } from "../CircleAIIntroModal";
import { useIsCircleAIIntroEligible } from "./useIsCircleAIIntroEligible";

const CIRCLE_AI_INTRO_MODAL_SEEN_KEY = "circle-ai-intro-modal-seen";

const getStorageKey = (memberId?: number) =>
  `${CIRCLE_AI_INTRO_MODAL_SEEN_KEY}_${memberId}`;

export const useRenderCircleAIIntroModal = () => {
  const { currentCommunityMember } = usePunditUserContext();
  const isEligible = useIsCircleAIIntroEligible();
  const { getValue: hasSeenModal, setValue: markModalAsSeen } =
    useLocalStorage<boolean>(getStorageKey(currentCommunityMember?.id));
  const modal = useCircleAIIntroModal();

  useEffect(() => {
    if (!isEligible || hasSeenModal()) return;

    markModalAsSeen(true);
    void modal.show();
  }, [modal, isEligible, hasSeenModal, markModalAsSeen]);
};
